import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import './HighlightedVenue.scss';

const HighlightedVenue = ({
  venue, baseRequestUrl, handleDirTagging,
}) => {
  const {
    pgm_dir_bottom: pgmDirBottom, pgm_dir_left: pgmDirLeft, pgm_dir_continent: pgmDirContinent, image, name, cuisine, city_name: cityName, bookNowLink,
  } = venue;
  const positionStyle = {
    bottom: pgmDirBottom,
    left: pgmDirLeft,
  };

  const renderContents = () => (
    <div className="inside_box">
      <h3 className="GDADir__HighlightedVenue--continent">{pgmDirContinent}</h3>
      <div
        className="GDADir__HighlightedVenue--image"
        style={{
          backgroundImage: `url(${baseRequestUrl}FeaturedVenues/${image})`,
        }}
      >
          &nbsp;
      </div>
      <h3 className="GDADir__HighlightedVenue--name">{name}</h3>
      <p className="GDADir__HighlightedVenue--features">
        {cuisine}
          &nbsp;&middot;&nbsp;
        {cityName}
      </p>
      <hr className="GDADir__HighlightedVenue--line" />
      {bookNowLink && (
      <p className="GDADir__HighlightedVenue--booknowlink">
        Learn More
      </p>
      )}

      {(!bookNowLink) && (
      <p className="GDADir__HighlightedVenue--booknowEmpty">
        Contact Amex to Book
      </p>
      )}
    </div>
  );

  const extraParams = {
    item_name: name,
    action_name: 'Highlighted Venue Click',
  };

  if (bookNowLink) {
    return (
      <div className="GDADir__HighlightedVenue outside_box" style={positionStyle}>
        <Link
          href={bookNowLink}
          target="_blank"
          rel="noopener noreferrer"
          onContextMenu={() => handleDirTagging(extraParams)}
          onClick={() => handleDirTagging(extraParams)}
        >
          {renderContents()}
        </Link>
      </div>
    );
  }
  return (
    <div className="GDADir__HighlightedVenue outside_box" style={positionStyle}>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */}
      <div tabIndex={0} className="noLink">
        {renderContents()}
      </div>
    </div>
  );
};

HighlightedVenue.propTypes = {
  venue: PropTypes.shape({
    pgm_dir_continent: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string,
    cuisine: PropTypes.string,
    currency: PropTypes.string,
    city_name: PropTypes.string,
    price: PropTypes.string,
    price_range: PropTypes.number,
    bookNowLink: PropTypes.string,
    venue_url: PropTypes.string,
    venue_url_text: PropTypes.string,
    pgm_dir_bottom: PropTypes.string,
    pgm_dir_left: PropTypes.string,
  }).isRequired,
  baseRequestUrl: PropTypes.string.isRequired,
  handleDirTagging: PropTypes.func.isRequired,
};

export default HighlightedVenue;
